import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FixelDataContext from "../../../context/FixelDataContext";
import { prepFBAudiences } from "../../../services/dataService";
import { ReactComponent as LeftArrow } from "../img/Left_Arrow.svg";
import {
    formDataWithToken,
    getFBAudiences,
    sendFBAccountToFixelApi,
    wpUrl
} from "../../../services/globalService"
import {
    IntContainer,
    Title,
    StyledP,
    StyledGoBack,
    StyledPlatformLabel,
    Button3,
    StyledPlatformsList,
    StyledFBIntegrationForm,
} from "../setup.style";
import ToggleButton from "../ToggleButton";
import ConnectFB from "./ConnectFB";
import SelectFBAccount from "./SelectFBAccount";
import FBConnectedAccount from "./FBConnectedAccount";
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from "../../../services/firebase";

const IntFacebook = () => {
    const history = useHistory();
    const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
    const [user] = useAuthState(Firebase.auth);
    const [error,setError] = useState('The connection to Facebook failed, please try again');

    const [FbIsOn, setFbIsOn] = useState(
        fullFixelData &&
        fullFixelData.install_data &&
        fullFixelData.install_data.options &&
        fullFixelData.install_data.options.fb,
    );
    const [FBState, setFBState] = useState({
        FBConnected: false,
        showSelectAccount: false,
        showConnectFB: false,
        connectionFailed: false,
        noAudiencesChecked: false,
        fbAccountData: [],
        selectedAccountIndex: -1,
        selectedPixelIndex: -1,
    });

    const renderConnectToFB = () =>
        setFBState({
            ...FBState,
            FBConnected: false,
            connectionFailed: false,
            showConnectFB: true,
        });

    const renderConnectionFailed = () =>
        setFBState({
            ...FBState,
            FBConnected: false,
            showSelectAccount: false,
            showConnectFB: true,
            connectionFailed: true,
        });

    const renderFBOff = () =>
        setFBState({
            ...FBState,
            FBConnected: false,
            showSelectAccount: false,
            showConnectFB: false,
        });

    const renderConnectedToFB = () =>
        setFBState({
            ...FBState,
            FBConnected: true,
        });

    useEffect(() => {
        // if fb flag true
        if (FbIsOn) {
            if (fullFixelData.facebook && fullFixelData.facebook.status === "connected") {
                // if facebook connected (FixelAPI has audiences)
                return renderConnectedToFB();
            } else if (fullFixelData.facebook && fullFixelData.facebook.status === "not connected") {
                return renderConnectToFB();
            } else {
                return renderConnectionFailed();
            }
        } else {
            // if toggle off display nothing
            return renderFBOff();
        }
    }, [FbIsOn, fullFixelData?.facebook?.status]);

    const getFBData = async () => {
        if(process.env.NODE_ENV !== 'production') {
            console.info('Function: getFBData, Line 103 (In getFBData): ');
        }
        try {
            const FBAudiences = await getFBAudiences(fullFixelData.code);
            if (FBAudiences?.data) {
                return {
                    audience: prepFBAudiences(FBAudiences.data.data),
                    status: "connected",
                    showFBAudiences: true,
                };
            }
            return { status: "not connected", showFBAudiences: false };
        } catch (error) {
            console.error("TCL ~ file: LoadingPage.js ~ getFbAudience ~ error", error.message || error);
        }
    };

    const updateFBPlatform = async () => {
        try {
            return await formDataWithToken(wpUrl, {
                action: 'fxl_edit_platforms',
                data: {
                    ...fullFixelData.install_data.options,
                    fb: FbIsOn,
                    platforms: !FBState.noAudiencesChecked,
                }
            });
        } catch (error) {
            console.error(
                "TCL ~ file: ConnectPlatforms.js ~ modifyPlatforms ~ error",
                error.message || error,
            );
        }
    };
    const onSaveFBIntegration = async (e) => {
        e.preventDefault();
        try {
            let newFixelData = { ...fullFixelData };
            let didSendFBAccount = true;
            let isPlatformUpdated = true;

            const shouldSendFBAccount =
                FbIsOn && !FBState.noAudiencesChecked && FBState.fbAccountData.length;
            if (shouldSendFBAccount) {
                didSendFBAccount = await sendFBAccountToFixelApi(FBState,user,fullFixelData);
                if(process.env.NODE_ENV !== 'production') {
                    console.info('Function: onSaveFBIntegration, Line 147 (): ', didSendFBAccount);
                }
                if (didSendFBAccount) {
                    newFixelData.facebook = await getFBData();
                }
            } else {
                newFixelData.facebook.showFBAudiences = false;
            }
            // user integrated to facebook, set tracked platforms to true
            if (didSendFBAccount) {
                isPlatformUpdated = await updateFBPlatform();
                if (isPlatformUpdated) {
                    if (shouldSendFBAccount || !FbIsOn || (FbIsOn && FBState.noAudiencesChecked)) {
                        newFixelData.install_data.options.fb = FbIsOn;
                        if (!FbIsOn) {
                            newFixelData.facebook.status = { status: "not connected", showFBAudiences: false };
                        }
                        setFullFixelData({
                            ...fullFixelData,
                            ...newFixelData,
                        });
                        if (newFixelData.facebook.status === "connected") {
                            renderConnectedToFB();
                        }
                    }
                }
            }
            if (!(didSendFBAccount && isPlatformUpdated)) {
                return renderConnectionFailed();
            }
            history.push("/setup");
        } catch (error) {
            console.log('Function: onSaveFBIntegration, Line 182 (error catcher): '
            , error);
            if(error.response.data){
                setError(error.response.data)
                renderConnectionFailed();
            }
            console.error(
                "TCL ~ file: IntFacebook.js ~ onSaveFBIntegration ~ error",
                error.message || error,
            );
        }
    };
    const showFBConnectedAccount = () => {
        return !FBState.showSelectAccount && FBState.FBConnected && !FBState.noAudiencesChecked;
    };

    const doneSelectFBAccount =
        FBState?.showSelectAccount &&
        FBState?.selectedAccountIndex !== -1 &&
        FBState?.selectedPixelIndex !== -1;

    const changedToggle =
        fullFixelData?.install_data && FbIsOn !== fullFixelData?.install_data?.options?.fb;
    const enableSaveButton =
        (!FbIsOn && changedToggle) || //fb has changed to off
        (FbIsOn && (FBState.noAudiencesChecked || doneSelectFBAccount)); // fb is true, and advanced has either picked or passed.

    return (
        <IntContainer>
            <StyledGoBack onClick={() => history.goBack()}>
                <LeftArrow />
                Go Back
            </StyledGoBack>
            <Title>Reach high value users with&nbsp;Facebook Ads</Title>
            <StyledP>
                Fixel automagically integrates with your favorite ad platforms for creating high value
                audiences.
            </StyledP>

            <StyledFBIntegrationForm onSubmit={onSaveFBIntegration}>
                <StyledPlatformsList>
                    <li>
                        <StyledPlatformLabel>Facebook Ads</StyledPlatformLabel>
                        <ToggleButton setOn={setFbIsOn} isOn={FbIsOn} />
                    </li>
                </StyledPlatformsList>

                {FBState.showConnectFB && !FBState.showSelectAccount && (
                    <ConnectFB setFBState={setFBState} FBState={FBState} error={error} />
                )}

                {FBState.showSelectAccount && <SelectFBAccount setFBState={setFBState} FBState={FBState} />}

                {showFBConnectedAccount() ? (
                    <FBConnectedAccount setFBState={setFBState} FBState={FBState} />
                ) : (
                    <Button3 disabled={!enableSaveButton} type="submit">
                        Save
                    </Button3>
                )}
            </StyledFBIntegrationForm>
        </IntContainer>
    );
};
export default IntFacebook;
